export const movies = [
  {
    id: "m01",
    title: "星际远征",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    director: "陈墨白",
    actors: ["林浩然", "苏晚晴", "周牧"],
    rating: 8.7,
    popularity: 9860,
    addedAt: "2024-09-28",
    summary:
      "一支科研舰队穿越虫洞寻找新家园，在未知星系中遭遇超乎想象的文明，人类必须在信念与生存之间做出抉择。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20film%20poster%20artwork%20for%20a%20Chinese%20interstellar%20space%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20dramatic%20rim%20lighting%2C%20minimalist%20clean%20gradient%20background%2C%20elegant%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m01&orientation=portrait",
  },
  {
    id: "m02",
    title: "长安秘闻录",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "悬疑", "剧情"],
    director: "顾长风",
    actors: ["谢云舟", "白凝", "沈砚"],
    rating: 8.4,
    popularity: 8420,
    addedAt: "2023-11-12",
    summary:
      "盛唐长安接连发生离奇命案，一位年轻的推官与神秘验尸官联手追查，逐步揭开隐藏在繁华之下的惊天秘闻。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20costume%20drama%20film%20poster%20for%20a%20Chinese%20Tang%20dynasty%20mystery%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20dramatic%20candlelight%2C%20minimalist%20clean%20background%2C%20elegant%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m02&orientation=portrait",
  },
  {
    id: "m03",
    title: "无声追缉",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["动作", "犯罪", "惊悚"],
    director: "潘志豪",
    actors: ["张家豪", "何靖", "欧阳雪"],
    rating: 8.1,
    popularity: 7760,
    addedAt: "2024-08-03",
    summary:
      "一名沉默寡言的缉毒警探独自追查跨国走私网络，在霓虹闪烁的都市夜色中，真相远比枪火更加冰冷。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20film%20poster%20for%20a%20Hong%20Kong%20city%20action%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20neon%20rim%20lighting%2C%20minimalist%20clean%20background%2C%20moody%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m03&orientation=portrait",
  },
  {
    id: "m04",
    title: "城市微光",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    director: "许知远",
    actors: ["程安然", "顾亦凡", "李禾"],
    rating: 7.9,
    popularity: 6210,
    addedAt: "2022-12-20",
    summary:
      "两个在城市里奔波的陌生人，因为一间深夜便利店而相识，在平凡的日子里彼此照亮，也学会了与自己和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20drama%20film%20poster%20for%20a%20Chinese%20urban%20love%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20bokeh%20lights%2C%20minimalist%20clean%20background%2C%20tender%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m04&orientation=portrait",
  },
  {
    id: "m05",
    title: "荒野孤旅",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["冒险", "剧情", "生存"],
    director: "Ethan Cole",
    actors: ["马修·雷恩", "艾拉·斯通", "诺亚·贝克"],
    rating: 8.2,
    popularity: 7130,
    addedAt: "2023-06-15",
    summary:
      "一位失去方向的旅人深入无人荒野，在极端自然环境中重新认识生命的意义，孤独既是惩罚，也是救赎。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wilderness%20adventure%20film%20poster%20for%20an%20American%20survival%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20golden%20hour%20lighting%2C%20minimalist%20clean%20background%2C%20epic%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m05&orientation=portrait",
  },
  {
    id: "m06",
    title: "深海回响",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "惊悚"],
    director: "陈墨白",
    actors: ["周牧", "白凝", "张扬"],
    rating: 8.5,
    popularity: 8290,
    addedAt: "2024-10-05",
    summary:
      "深海科考站突然失去联络，一支救援队潜入万米海底，却在黑暗中听到了本不该存在的声音，真相沉在更深的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20sci%20fi%20film%20poster%20for%20a%20Chinese%20underwater%20mystery%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20dramatic%20underwater%20light%20rays%2C%20minimalist%20clean%20background%2C%20tense%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m06&orientation=portrait",
  },
  {
    id: "m07",
    title: "盛夏光年",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["青春", "爱情", "剧情"],
    director: "许知远",
    actors: ["李禾", "苏晚晴", "程安然"],
    rating: 7.6,
    popularity: 5480,
    addedAt: "2021-07-18",
    summary:
      "高考结束的那个夏天，三个少年在海边小城许下约定，多年后重逢，才发现有些光年从未走远，只是换了一种方式照亮彼此。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20coming%20of%20age%20film%20poster%20for%20a%20Chinese%20summer%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20sunset%20lighting%2C%20minimalist%20clean%20background%2C%20nostalgic%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m07&orientation=portrait",
  },
  {
    id: "m08",
    title: "迷雾追踪",
    type: "movie",
    year: 2024,
    region: "韩国",
    genres: ["犯罪", "悬疑", "剧情"],
    director: "金秀贤",
    actors: ["李在勋", "韩素拉", "朴志勋"],
    rating: 8.3,
    popularity: 7920,
    addedAt: "2024-09-11",
    summary:
      "一场持续二十年的连环悬案，随着一名老刑警的退休重新浮出水面，浓雾散去之后，答案指向了所有人都意想不到的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20korean%20crime%20thriller%20film%20poster%20for%20a%20rainy%20city%20mystery%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20foggy%20moody%20lighting%2C%20minimalist%20clean%20background%2C%20tense%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-m08&orientation=portrait",
  },
  {
    id: "t01",
    title: "山河故梦",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "剧情", "历史"],
    director: "郑柏舟",
    actors: ["谢云舟", "沈砚", "白凝"],
    rating: 8.8,
    popularity: 9640,
    addedAt: "2024-10-02",
    summary:
      "少年将军背负家族冤屈重返朝堂，在权谋与山河之间周旋，既有金戈铁马，也有藏于心底的故人与旧梦。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20tv%20drama%20poster%20for%20a%20Chinese%20ancient%20general%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20dramatic%20banner%20lighting%2C%20minimalist%20clean%20background%2C%20epic%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t01&orientation=portrait",
  },
  {
    id: "t02",
    title: "都市浮生录",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "家庭", "剧情"],
    director: "许知远",
    actors: ["程安然", "李禾", "顾亦凡"],
    rating: 8.0,
    popularity: 7020,
    addedAt: "2023-10-21",
    summary:
      "一栋写字楼里的四组家庭，在升职、育儿、婚姻与亲情的夹缝中努力生活，平凡人的故事自有动人的分量。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20modern%20urban%20tv%20drama%20poster%20about%20city%20family%20life%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20window%20light%2C%20minimalist%20clean%20background%2C%20warm%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t02&orientation=portrait",
  },
  {
    id: "t03",
    title: "法证先锋者",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "悬疑", "职场"],
    director: "潘志豪",
    actors: ["何靖", "欧阳雪", "张扬"],
    rating: 8.4,
    popularity: 8130,
    addedAt: "2024-09-19",
    summary:
      "一群年轻的法证与刑侦人员，用科学与逻辑还原每一个案发现场，在冰冷的证据背后，寻找人性留下的温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20forensic%20crime%20tv%20drama%20poster%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20cool%20lab%20lighting%20with%20warm%20accents%2C%20minimalist%20clean%20background%2C%20clean%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t03&orientation=portrait",
  },
  {
    id: "t04",
    title: "深宫旧梦",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "爱情", "宫斗"],
    director: "顾长风",
    actors: ["白凝", "沈砚", "苏晚晴"],
    rating: 7.7,
    popularity: 6380,
    addedAt: "2022-08-30",
    summary:
      "入宫那年的杏花开得正好，她从天真少女一步步走到权力中心，回头看时，旧梦与真心都已换了模样。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20palace%20costume%20romance%20tv%20drama%20poster%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20lantern%20lighting%2C%20minimalist%20clean%20background%2C%20elegant%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t04&orientation=portrait",
  },
  {
    id: "t05",
    title: "烈焰突击",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["战争", "动作", "剧情"],
    director: "郑柏舟",
    actors: ["张家豪", "林浩然", "周牧"],
    rating: 8.2,
    popularity: 7590,
    addedAt: "2023-07-07",
    summary:
      "一支尖刀小队深入敌后执行绝密任务，在枪林弹雨与生死考验中，他们用血肉之躯守住身后的万家灯火。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20action%20tv%20drama%20poster%20for%20a%20military%20special%20forces%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20smoke%20and%20fire%20glow%2C%20minimalist%20clean%20background%2C%20heroic%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t05&orientation=portrait",
  },
  {
    id: "t06",
    title: "医心仁术",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "职场", "家庭"],
    director: "许知远",
    actors: ["程安然", "张扬", "何靖"],
    rating: 8.1,
    popularity: 7210,
    addedAt: "2024-08-25",
    summary:
      "急诊科的日与夜永不停歇，一群医护人员在一次次抢救中直面生死，也在疲惫与坚持之间理解医者二字的重量。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20tv%20poster%20for%20a%20hospital%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20clean%20lighting%2C%20minimalist%20background%2C%20calm%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t06&orientation=portrait",
  },
  {
    id: "t07",
    title: "江湖夜雨",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["武侠", "古装", "剧情"],
    director: "顾长风",
    actors: ["谢云舟", "白凝", "林浩然"],
    rating: 8.5,
    popularity: 8460,
    addedAt: "2023-05-16",
    summary:
      "一柄断剑，一段旧约。少年剑客行走江湖，在恩怨情仇与家国大义之间，写下属于自己的传说。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20martial%20arts%20tv%20drama%20poster%20for%20a%20jianghu%20swordsman%20story%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20rainy%20moody%20lighting%2C%20minimalist%20clean%20background%2C%20dynamic%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t07&orientation=portrait",
  },
  {
    id: "t08",
    title: "归途列车",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["家庭", "剧情"],
    director: "郑柏舟",
    actors: ["李禾", "程安然", "沈砚"],
    rating: 7.9,
    popularity: 5960,
    addedAt: "2022-11-04",
    summary:
      "春运的绿皮火车上，三组素不相识的旅客因为一场意外相遇，在漫长归途里交换了彼此的人生故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20tv%20poster%20about%20a%20train%20journey%20home%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20warm%20cabin%20lighting%2C%20minimalist%20clean%20background%2C%20tender%20composition%2C%20high%20detail%2C%20premium%20editorial%20streaming%20aesthetic&width=600&height=900&seq=film-t08&orientation=portrait",
  },
  {
    id: "v01",
    title: "快乐向前冲",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "真人秀", "搞笑"],
    director: "综艺中心",
    actors: ["何炅炅", "谢小娜", "汪小涵"],
    rating: 8.0,
    popularity: 8820,
    addedAt: "2024-09-30",
    summary:
      "素人与明星组队挑战趣味闯关赛道，笑料与汗水齐飞，用最简单的方式传递快乐与坚持的力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20television%20variety%20show%20key%20art%20with%20energetic%20stage%20lighting%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20festive%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20joyful%20composition%2C%20high%20detail&width=600&height=900&seq=film-v01&orientation=portrait",
  },
  {
    id: "v02",
    title: "星光舞台",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "竞技", "真人秀"],
    director: "音乐频道",
    actors: ["周牧", "苏晚晴", "白凝"],
    rating: 8.3,
    popularity: 8310,
    addedAt: "2024-10-12",
    summary:
      "来自各行各业的音乐爱好者同台竞演，在聚光灯下唱出普通人的梦想，每一次登台都是与自己的对话。",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20variety%20show%20key%20art%20with%20spotlight%20stage%20glow%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20elegant%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20dramatic%20composition%2C%20high%20detail&width=600&height=900&seq=film-v02&orientation=portrait",
  },
  {
    id: "v03",
    title: "美食奇遇记",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["美食", "真人秀", "旅行"],
    director: "生活频道",
    actors: ["李禾", "程安然", "欧阳雪"],
    rating: 7.8,
    popularity: 6640,
    addedAt: "2023-09-08",
    summary:
      "主持人带着镜头走遍大江南北，探访藏在街头巷尾的地道风味，在一饭一蔬间感受最真实的人间烟火。",
    cover:
      "https://readdy.ai/api/search-image?query=Food%20travel%20variety%20show%20key%20art%20with%20warm%20kitchen%20lighting%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20cozy%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20appetizing%20composition%2C%20high%20detail&width=600&height=900&seq=film-v03&orientation=portrait",
  },
  {
    id: "v04",
    title: "荒野挑战营",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["户外", "真人秀", "竞技"],
    director: "综艺中心",
    actors: ["张家豪", "何靖", "张扬"],
    rating: 8.1,
    popularity: 7480,
    addedAt: "2024-08-17",
    summary:
      "八位嘉宾深入深山与海岛，在有限的资源下完成生存挑战，展现团队协作与突破自我的热血时刻。",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20survival%20reality%20show%20key%20art%20with%20campfire%20and%20night%20sky%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20adventurous%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20epic%20composition%2C%20high%20detail&width=600&height=900&seq=film-v04&orientation=portrait",
  },
  {
    id: "v05",
    title: "声动人心",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["音乐", "竞演", "真人秀"],
    director: "音乐频道",
    actors: ["苏晚晴", "周牧", "谢小娜"],
    rating: 7.9,
    popularity: 6890,
    addedAt: "2023-12-01",
    summary:
      "实力唱将同台对决，用歌声讲述歌曲背后的故事，每一次深情演绎都能触动观众心底最柔软的角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Singing%20competition%20variety%20show%20key%20art%20with%20warm%20stage%20lights%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20emotional%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=film-v05&orientation=portrait",
  },
  {
    id: "v06",
    title: "热血逐梦团",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "青春", "真人秀"],
    director: "综艺中心",
    actors: ["林浩然", "白凝", "汪小涵"],
    rating: 8.2,
    popularity: 7960,
    addedAt: "2024-09-06",
    summary:
      "一群怀揣梦想的年轻人在专业赛场上展开集训与对决，汗水、友情与成长交织成最热血的青春群像。",
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20sports%20competition%20variety%20show%20key%20art%20with%20dynamic%20arena%20lighting%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20energetic%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20high%20detail&width=600&height=900&seq=film-v06&orientation=portrait",
  },
  {
    id: "v07",
    title: "诗词雅集",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["文化", "知识", "竞赛"],
    director: "文化频道",
    actors: ["沈砚", "程安然", "顾亦凡"],
    rating: 8.6,
    popularity: 8620,
    addedAt: "2023-11-25",
    summary:
      "以古典诗词为题的雅集竞演，选手们在飞花令与名篇赏析中，重温流传千年的文字之美与东方浪漫。",
    cover:
      "https://readdy.ai/api/search-image?query=Cultural%20poetry%20variety%20show%20key%20art%20with%20ink%20wash%20and%20lantern%20lighting%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20elegant%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20refined%20composition%2C%20high%20detail&width=600&height=900&seq=film-v07&orientation=portrait",
  },
  {
    id: "v08",
    title: "欢乐嘉年华",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "综艺", "搞笑"],
    director: "综艺中心",
    actors: ["谢小娜", "汪小涵", "何炅炅"],
    rating: 7.7,
    popularity: 6320,
    addedAt: "2024-07-19",
    summary:
      "爆笑游戏与即兴情景轮番上演，嘉宾放下偶像包袱全力搞笑，只为把最简单的快乐送到每一位观众面前。",
    cover:
      "https://readdy.ai/api/search-image?query=Comedy%20game%20variety%20show%20key%20art%20with%20playful%20confetti%20and%20bright%20lights%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20fun%20modern%20entertainment%20visual%2C%20clean%20minimal%20background%2C%20high%20detail&width=600&height=900&seq=film-v08&orientation=portrait",
  },
];

export const bannerSlides = [
  {
    id: "t01",
    title: "山河故梦",
    tagline: "权谋山河 · 少年归来，一出盛世悲欢",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20historical%20chinese%20drama%20banner%2C%20ancient%20palace%20silhouette%20under%20dramatic%20sky%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20wide%20composition%20with%20negative%20space%20for%20text%2C%20dark%20cinematic%20tone%2C%20high%20detail%20illustration&width=1600&height=900&seq=banner-v91-1&orientation=landscape",
  },
  {
    id: "m06",
    title: "深海回响",
    tagline: "万米海底 · 回声之下，藏着不能说的真相",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20science%20fiction%20banner%2C%20underwater%20light%20rays%20and%20submersible%20silhouette%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20wide%20composition%20with%20negative%20space%20for%20text%2C%20dark%20cinematic%20tone%2C%20high%20detail&width=1600&height=900&seq=banner-v91-2&orientation=landscape",
  },
  {
    id: "v02",
    title: "星光舞台",
    tagline: "聚光灯下 · 每一个平凡梦想都值得被听见",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20competition%20stage%20banner%2C%20spotlight%20beams%20and%20concert%20crowd%20silhouette%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20wide%20composition%20with%20negative%20space%20for%20text%2C%20dark%20cinematic%20tone%2C%20high%20detail&width=1600&height=900&seq=banner-v91-3&orientation=landscape",
  },
  {
    id: "m03",
    title: "无声追缉",
    tagline: "霓虹夜色 · 沉默的追捕，冰冷到底",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20city%20night%20banner%2C%20neon%20reflections%20on%20wet%20street%20and%20lone%20figure%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20wide%20composition%20with%20negative%20space%20for%20text%2C%20dark%20cinematic%20tone%2C%20high%20detail&width=1600&height=900&seq=banner-v91-4&orientation=landscape",
  },
  {
    id: "m05",
    title: "荒野孤旅",
    tagline: "无人之境 · 孤独既是惩罚，也是救赎",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wilderness%20adventure%20banner%2C%20vast%20mountain%20landscape%20at%20golden%20hour%20with%20small%20traveler%20figure%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20wide%20composition%20with%20negative%20space%20for%20text%2C%20high%20detail&width=1600&height=900&seq=banner-v91-5&orientation=landscape",
  },
];